export default "__VITE_ASSET__B9IqVwAh__"